import { render, staticRenderFns } from "./RoleDetails.vue?vue&type=template&id=60f4bc7d&scoped=true&"
import script from "./RoleDetails.vue?vue&type=script&lang=js&"
export * from "./RoleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4bc7d",
  null
  
)

export default component.exports